import { useNavigate } from "react-router-dom";
import AuiButton from "../../components/Buttons/Buttons";
import "./NoPermission.scss";
import { AdminRoles } from "../../utils/constants/app-constants";

const NoPermission = () => {
  const navigate = useNavigate();
  const userRole = localStorage.getItem("role") ?? "";
  const onBackBtnHandle = () => {
    if (
      userRole === AdminRoles.SponsoringAdmin ||
      userRole === AdminRoles.MasterTrainer ||
      userRole === AdminRoles.ApprovingAdmin
    ) {
      navigate("/course-listing");
    } else if (userRole === AdminRoles.SuperAdmin) {
      navigate("/organization-listing");
    } else {
      navigate("/");
    }
  };
  return (
    <div className="page-404 no-access-page">
      <div className="container">
        <div className="w-100">
          <aui-globalerror errortype="secondary" heading="Access Not Yet Enabled">
            <p className="pb-3">
              You’ve signed in successfully, but your account does not yet have access to this application.<br />
              Please contact your administrator to request access.
            </p>
            <p><strong>Approved Trainers</strong>: Go to <a className="consent-link" href="/user-consent">User Consent</a> and submit the required information and supporting documents.</p>
            {/* <AuiButton
              onClick={onBackBtnHandle}
              className="mt-6 px-6 py-2 text-white bg-red-600 rounded-lg hover:bg-red-700 transition"
              variant={"primary"}
              buttontitle="Return to home page"
              buttonid={""}
              data-testid="back-button"
            ></AuiButton> */}
          </aui-globalerror>
        </div>
      </div>
    </div>
  );
};

export default NoPermission;
